import {Collection} from "vue-mc"
import resourceModel from "@/models/resourceModel"

import Vue from "vue";

export default class resourceCollection extends Collection {

	model() {
		return resourceModel;
	}

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'menu',
			resource_type_id: 0,
			category_id: 0,
			data: {},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				menu: 'GET',
				list: 'GET'
			}
		}
	}

	routes() {
		return {
			menu: 'interpreter/resources/menu',
			list: 'interpreter/resources/list/{resource_type_id}/{category_id}'
		}
	}

	requestRoute() {

		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.getAttributes().methodTypes);
		let route = this.getAttributes().inBuiltApi + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.getAttributes().data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getMenuList() {
		this.getAttributes().methodTypes = 'menu';
		return this.requestRoute();
	}

	getList(resourceTypeID, categoryID) {
		this.getAttributes().methodTypes = 'list';
		this.getAttributes().resource_type_id = resourceTypeID;
		this.getAttributes().category_id = categoryID;
		return this.requestRoute();
	}
}
